<style>
.role table  tr th{
  text-align: center;
}
.role table  td:nth-child(1){
  text-align: center;
}
</style>
<template>
  <div class="dynamic-tables">
    <Widget title="<h4>Role</h4>" collapse close customHeader>
      <div class="form-group row">
        <div class="col-sm-6">
          <b-button variant="success" v-b-modal.modal-tambah><span class="glyphicon glyphicon-plus mb-2" /> Tambah
          </b-button>
        </div>
        <div class="col-sm-6 text-end">
        </div>
      </div>
      <div class="role">
        <v-client-table :data="itemsWithNumber" :columns="columnsDatatable" :options="optionsRoles">
          <div slot="aksi" slot-scope="props">
            <b-button variant="info" class="me-3" size="s" @click="getDetail(props.row.id)">
              <i class="glyphicon glyphicon-pencil text-white me-sm-1 mb-sm-2" />
              <span class="d-none d-md-inline-block text-white"> Edit</span>
            </b-button>
            <b-button style="margin-left:5px" variant="danger" class="me-3" size="s" @click="deleteData(props.row.id)">
              <i class="glyphicon glyphicon-trash text-white me-sm-1 mb-sm-2" />
              <span class="d-none d-md-inline-block text-white"> Hapus</span>
            </b-button>
          </div>
        </v-client-table>
      </div>
      </Widget>
    </Widget>

    <!-- modal tambah -->
    <b-modal body-class="bg-white" id="modal-tambah" scrollable title="Tambah Data" cancel-title="Close"
      ok-title="Accept" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-form-group label="Nama" label-for="name" class="mb-3">
          <b-form-input v-validate="'required'" name="nama"
            :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.nama') }" id="name"
            v-model="dataRoles.name" />
          <span class="text-danger" v-if="errors.has('form-1.nama')">
            {{ errors.first('form-1.nama') }}
          </span>
        </b-form-group>

      </form>


      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="onSubmit">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal tambah -->
    <b-modal body-class="bg-white" id="modal-edit" scrollable title="Edit Data" cancel-title="Close" ok-title="Accept"
      cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata">
        <b-form-group label="Nama" label-for="name" class="mb-3">
          <b-form-input v-validate="'required'" name="nama"
            :class="{ 'form-control': true, 'is-invalid': errors.has('nama') }" id="name" v-model="dataRoles.name" />
          <span class="text-danger" v-if="errors.has('nama')">
            {{ errors.first('nama') }}
          </span>
        </b-form-group>
      </form>


      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="editData(dataRoles.id)">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
  
<script>
import Widget from '@/components/Widget/Widget';
import axios from 'axios';
import Swal from 'sweetalert2'

export default {
  name: 'Dynamic',
  components: { Widget },
  data() {
    return {
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem('user')),
      columnsDatatable: ['no','name', 'aksi'],
      dataUser: [],
      dataRoles: [],
      dataRole: [],
      optionsRoles: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: '', count: '', limit: '' },
        columnsClasses: { no: 'width-100' },
        skin: 'table table-striped',
        sortIcon: {
          base: 'fa text-muted', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort',
        },
      },
    };
  },
  mounted() {
    this.loaddata()
  },
  computed: {
      itemsWithNumber() {
        return this.dataRole.map((d, index) => ({ ...d, no: index + 1 }))
      }
  },
  methods: {
    deleteData(id) {
      Swal.fire({
        title: 'Hapus Data?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya'
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(
              this.baseapi + `api/role/` + id,
              {
                headers: {
                  Authorization: `Bearer ` + this.user.accessToken
                }
              }
            )
            .then((res) => {
              this.$toasted.success("Berhasil Dihapus");
              this.loaddata()
              return res;
            })
            .catch((err) => {
              console.log(err)
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      })
    },
    onSubmit() {
      this.$validator.validateAll('form-1').then((result) => {
        if (result) {
          axios.post(this.baseapi + 'api/role', {
            name: this.dataRoles.name,
          },{
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ` + this.user.accessToken
            }
          })
            .then((res) => {
              this.$toasted.success("Berhasil Ditambah");
              this.loaddata()
              this.dataRoles = []

              // Wait until the models are updated in the UI
              this.$nextTick(() => {
                this.$bvModal.hide('modal-tambah')
              });
              return res;
            })
            .catch((err) => {
              console.log(err)
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      })
    },

    editData(id) {
      this.$validator.validateAll();
      axios
        .put(
          this.baseapi + `api/role/${id}`,
          {
            // idptsp,
            name: this.dataRoles.name,
          }
          , {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken
            }
          })
        .then((res) => {
          this.$toasted.success("Berhasil Diubah");
          this.this.dataRoles = []
          this.loaddata()

          this.$nextTick(() => {
            this.$bvModal.hide('modal-edit')
          })
          return res;
        })
        .catch((err) => {
          console.log(err)
          this.$toasted.error(err.response.data.message);
          return err;
        });
    },

    // loaddata user
    loaddata() {
      axios.get(this.baseapi + "api/role", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataRole = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // detail
    getDetail(id) {
      axios.get(this.baseapi + "api/role/" + id, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataRoles = response.data.data;
        this.$nextTick(() => {
          this.$bvModal.show('modal-edit')
        });
      }).catch(error => {
        console.log(error)
        return error
      });
    }
  },
};
</script>
  
  

<style src="./Role.scss" lang="scss" />
  